import useSWR from 'swr';
import { REVALIDATE_KEY, SWR_REQUEST_CONFIG } from '@/api/hooks/_constants';
import { getCategory } from '@/api/get-category';
import { TGetCategoryRequestProps } from '@/api/get-category/_types';

export const useCategory = (params: TGetCategoryRequestProps) => {
  const canMakeRequest = Boolean(params.id);

  const { data, error, isLoading } = useSWR(
    canMakeRequest ? { key: REVALIDATE_KEY.CATEGORY, ...params } : null,
    () => getCategory(params),
    SWR_REQUEST_CONFIG,
  );

  return {
    data,
    isLoading,
    isError: error,
  };
};
